import { GIF } from './GIF'

export default GIF